import React from 'react';
import {Scrollbar} from '@priority-software/priority-style-react';
import {priority} from '@priority-software/priority-proto-api/lib';
import {ChangeLog} from './ChangeLog';
import {EmptyState} from './EmptyState';
import styles from '../styles/historyContent.module.scss';
import {fetchMore} from '../../Common/actions';
import {Record} from '../../../../../../stores/Form/Record';
import {useState} from 'react';
import {changeLogDefaultFields} from '../consts';
import {SearchBlock} from '../../Common/components/SearchBlock';
import {SettingsPanelCol} from '../../Common/consts';

type Props = {
    logs: Record[];
    shouldFetchMore: boolean;
    isLegacyStore: boolean;
    fastSearchQuery: string;
    enabledCols: string[];
    applySettings: (cols: SettingsPanelCol[]) => Promise<void>;
    subformType: priority.netitems.form.SubformType;
};

export const ChangesTabContent = ({
    logs,
    shouldFetchMore,
    isLegacyStore,
    fastSearchQuery,
    enabledCols,
    applySettings,
    subformType
}: Props) => {
    const [searchQuery, setSearchQuery] = useState('');
    const handleScrollEnd = async () => {
        if (shouldFetchMore) {
            fetchMore(logs[0].parentForm, logs);
        }
    };

    return (
        <div className={styles.tabContainer}>
            {(logs?.length || !!fastSearchQuery) && (
                <SearchBlock
                    searchQuery={searchQuery}
                    onSearchChange={setSearchQuery}
                    isServerSearch={true}
                    records={logs}
                    defaultCols={changeLogDefaultFields}
                    enabledCols={enabledCols}
                    componentClasses={styles.searchBlockWrapper}
                    applySettings={applySettings}
                    subformType={subformType}
                />
            )}
            {logs.length > 0 ? (
                <Scrollbar onScrollEnd={handleScrollEnd}>
                    {logs.map(log => {
                        return (
                            <ChangeLog
                                log={log}
                                key={log.clientKey}
                                isLegacyStore={isLegacyStore}
                                searchQuery={searchQuery}
                                enabledCols={enabledCols}
                            />
                        );
                    })}
                </Scrollbar>
            ) : (
                <EmptyState isFastSearch={!!fastSearchQuery} />
            )}
        </div>
    );
};
